import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState } from "react";

function App() {
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [origin, setOrigin] = useState("");

  const API_URL = window._env_?.API_URL || "http://localhost:8080";

  useEffect(() => {
    fetch(`${API_URL}/hello`)
      .then((res) => res.text())
      .then((data) => setMessage(data))
      .catch((err) => console.error("Hiba:", err));
  }, [API_URL]);

  useEffect(() => {
    setOrigin(window.location.origin);
    console.log("Frontend origin:", window.location.origin);
  }, []);

  const sendName = () => {
    fetch(`${API_URL}/hello?name=${encodeURIComponent(name)}`)
      .then((res) => res.text())
      .then((data) => setMessage(data))
      .catch((err) => {
        console.error("Hiba:", err);
        setMessage("Hiba történt");
      });
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p style={{ marginBottom: "10px" }}>Frontend origin: {origin}</p>

        <p style={{ marginBottom: "10px" }}>Backend message: {message}</p>

        {/* Név + input + gomb egy sorban */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <span>Név:</span>
          <input
            type="text"
            placeholder="Írd be a neved"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ padding: "8px" }}
          />
          <button onClick={sendName} style={{ padding: "8px" }}>
            Küldés
          </button>
        </div>

        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
